import { lazy } from "react";
import { Route } from "react-router-dom";
import { UploadType } from "../../models/upload-type";

const DataHome = lazy(() => import("../../containers/data/DataHome"));
const DataSourceRecordUpload = lazy(() => import("../../containers/data/uploads/Overview"));
const RecordTab = lazy(() => import("../../containers/data/DataHome"));

export const local51Routes = (link: string) => [
	{
		key: "5.3.1",
		link: "/data/records/upload/:typeId",
		component: (props: any) => <DataSourceRecordUpload uploadType={UploadType.Records} uploadTypeId={props.match.params.typeId} />,
	},
	{ key: "5.1", link: link + "/:tab", component: (props: any) => <DataHome {...props} /> },
	{ key: "5.1", link: link + "/:tab/quests", component: (props: any) => <RecordTab {...props} /> },
];

export default function Key51Routes(key: string, link: string) {
	const key51Routes = [{ key: key, link: link, component: (props: any) => <DataHome {...props} /> }, ...local51Routes(link)];

	return key51Routes.map((r) => <Route exact key={r.key} path={r.link} render={r.component} />);
}
